import React from "react";
import "./style.scss";

import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Image from "../../elements/image";
import PropTypes from "prop-types";

const ContactSupportSubmitted = ({
  submittedheadingBody,
  submittedHeadingType,
  submittedBody,
  image
}) => {
  return (
    <React.Fragment>
      {submittedheadingBody.value && (
        <Heading
          className="title"
          type={submittedHeadingType}
          html={submittedheadingBody}
          typographyClass="type-h1"
        />
      )}

      <BodyText html={submittedBody.value} />

{image.value && image.value.src &&   <Image {...image.value} />}
    
    </React.Fragment>
  );
};

ContactSupportSubmitted.propTypes = {
  submittedheadingBody:PropTypes.object,
  submittedHeadingType:PropTypes.object,
  submittedBody:PropTypes.object,
  image:PropTypes.object
};
export default ContactSupportSubmitted;
